import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { AppTabularDto } from '../../dtos/app-tabular.dto';
import { DragBoxPluginChart } from '../plugins/draw-box.plugin';

// export interface ResetZoom {
//     resetZoom(): void
//   }
export interface DateZoomRange {
  startDate: Date;
  endDate: Date;
}

export const useOnZoomComplete = (
  data?: AppTabularDto<unknown>,
  setZoom?: (range: { startDate: Date; endDate: Date } | undefined) => void,
) => {
  const onZoomComplete = useCallback(
    ({ chart }: { chart: DragBoxPluginChart }) => {
      //const { scales: { x } } = chart;
      if (!setZoom) return;
      const range = chart.getRange();
      if (data?.rows) {
        if (!range) {
          setZoom(undefined);
        } else {
          const min: any = data.rows[range.startX];
          const max: any = data.rows[range.endX];
          if (min && max) {
            const startDate = moment(min.WEEK).toDate();
            const endDate = moment(max.WEEK).toDate();
            setZoom({ startDate, endDate });
          }
        }
      }
    },
    [data, setZoom],
  );

  return {
    onZoomComplete,
    onPanComplete: onZoomComplete,
  };
};

export const useZoomResetOnFilterSelection = (
  filterSelection: FilterSelectedValue[],
  resetZoomFunction?: () => void,
) => {
  // Reset when any filter changes.
  useEffect(() => {
    if (resetZoomFunction) {
      resetZoomFunction();
    }
  }, [resetZoomFunction, filterSelection]);
  return;
};

export const useZoomSetupResetCallback = (
  chart?: DragBoxPluginChart,
  setResetZoomCallback?: (resetZoom: DragBoxPluginChart) => void,
) => {
  // Setup reset function to allow parent component to reset zoom.
  useEffect(() => {
    if (setResetZoomCallback && chart) {
      setResetZoomCallback(chart);
    }
  }, [chart, setResetZoomCallback]);

  return;
};
